import { extend, override } from "flarum/common/extend";
import listItems from "flarum/common/helpers/listItems";
import humanTime from "flarum/utils/humanTime";
import IndexPage from "flarum/components/IndexPage";

export default function () {
  extend(IndexPage.prototype, "navItems", function (items) {
    if (items.has("following")) {
      items.items.following["priority"] = 991;
    }
  });
}
